import PropTypes from "prop-types";

import InfoSvg from "assets/svg/info.svg";
import EndeksaLogo from "assets/svg/endeksa_logo.svg";
import LocationIcon from "assets/svg/location_icon_3.svg";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import ContentOuterWrap from "components/listing-detail/content-outer-wrap";
import ListingDetailDistrictReport from "components/listing-detail/district-report";

import styles from "./styles.module.css";

const RegionReport = ({ listingData, districtReportPriceInfos, districtReportDemographicInfos, unitTypes }) => {
  const { tradeType, estateType } = listingData || {};
  const filteredUnitTypes = [
    ...new Map(
      unitTypes
        .filter((item) => item?.flatPrice != null)
        .map((item) => [
          item.roomCount,
          {
            ...item,
            name: item.roomType,
          },
        ])
    ).values(),
  ];
  // const listingSquareValue = info.find((item) => ["gross_square", "square"].includes(item.key))?.value;
  const listingEstateType = estateType?.name;
  const listingTradeTypeValue = tradeType?.id;
  const { townName } = districtReportDemographicInfos || districtReportPriceInfos || {};

  const handleSetGa4Event = () => {
    Ga4WithEventParameters({
      eventName: "click_widget",
      eventParameters: { widget: `bolge-raporu||endeksa` },
    });
  };

  return (
    <div className={styles.wrapper} id="bolge-raporu" data-scroll-selector>
      <div className={styles.titleWrapper}>
        <h2 className={styles.title}>Bölge Raporu</h2>
        <span
          // eslint-disable-next-line react/no-unknown-property
          tooltip="Bu modülde incelediğiniz ilanın bulunduğu bölgeye ait evlerin ortalama fiyatları ve bu bölgenin
                demografik yaşam özelliklerini görebilirsiniz."
          // eslint-disable-next-line react/no-unknown-property
          flow="right"
          className={styles.infoIcon}
        >
          <InfoSvg width="19" height="19" />
        </span>
      </div>
      <div className={styles.townInfo}>
        <LocationIcon />
        <p className={styles.townName}>{townName}</p>
      </div>
      <ContentOuterWrap>
        <ListingDetailDistrictReport
          listingTradeTypeValue={listingTradeTypeValue}
          listingEstateType={listingEstateType}
          districtReportPriceInfos={districtReportPriceInfos}
          districtReportDemographicInfos={districtReportDemographicInfos}
          listingData={listingData}
          isProjectPage={true}
          unitTypes={filteredUnitTypes}
        />

        <EndeksaLogo />
        <div className={styles.endeksaAbout}>
          Bölge Raporu, Endeksa&apos;dan almış olduğumuz veriler ışığında oluşturulmuştur. Aradığınız bölge ile ilgili
          detaylı rapora erişmek için
          <a
            href="https://www.endeksa.com/tr/"
            className={styles.endeksaRedirect}
            target="_blank"
            rel="noreferrer"
            onClick={handleSetGa4Event}
          >
            tıklayın.
          </a>
        </div>
      </ContentOuterWrap>
    </div>
  );
};

RegionReport.propTypes = {
  listingData: PropTypes.object,
  districtReportDemographicInfos: PropTypes.object,
  districtReportPriceInfos: PropTypes.object,
  unitTypes: PropTypes.array,
};

export default RegionReport;
